<template>
  <div>
    <div class="list-item">
      <v-btn
        :ripple="false"
        block
        color="white"
        class="list-item-btn"
        @click.stop="deleteCheck = true"
      >
        <div class="list-item-text">
          <span class="list-item-name">{{
            testator.company.trustCompanyName
          }}</span>
          <span class="list-item-separator">-</span>
          <span class="list-item-more-info">Trust administration company</span>
        </div>
      </v-btn>
    </div>

    <v-dialog
      v-model="deleteCheck"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <DeleteDialog
        :content="deleteDialogContent"
        @delete="removeCompanyAsTrustee"
        @dialogClosed="deleteCheck = false"
      />
    </v-dialog>
    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import DeleteDialog from '../common/DeleteDialog.vue';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { UPDATE_TESTATOR_MUTATION } from '../../constants/graphql/testators';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'CompanyTrusteeListItem',
    components: {
      DeleteDialog,
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        deleteCheck: false,
      };
    },
    computed: {
      deleteDialogContent() {
        return {
          title: `Remove ${this.testator.company.trustCompanyName}`,
          text: `Do you want to remove ${this.testator.company.trustCompanyName} as a Trustee?`,
          buttonText: `Yes, Remove`,
        };
      },
    },
    methods: {
      removeCompanyAsTrustee() {
        const testatorInputDetails = {
          companyIsTrustee: false,
        };
        const id = this.testator.id;

        this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(_response => {
            this.deleteCheck = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
    },
  };
</script>
